import { helper } from "lib/helper";
import { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip,
  Col,
} from "reactstrap";
import AddModal from "views/components/AddModal";
import "./style.css";
// core components
import TablePagination from "views/components/TablePagination";
import Loader from "components/loader/Loader";
import parentsModal from "models/parents.modal";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Swal from "sweetalert2";
import axios from "axios";
import ParentandtutoractiveModal from "models/activeanddeactive.modal";

const Students = () => {
  const [status, setStatus] = useState("?class_status=All");
  const [modal, setModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const toggleModal = (modalName) => {
    setModal(!modal);
  };

  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [totalpage, setTotalpage] = useState();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const initialPage = searchParams.get("page") || 1;
  const [currentPage, setCurrentPage] = useState(
    parseInt(initialPage, 10) || 1
  );
  const [perPage, setPerPage] = useState(10);

  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }
  const [alldata, setAlldata] = useState();
  const [activedata, setActivedata] = useState();
  const [holddata, setHolddata] = useState();
  const [completeddata, setCompleteddata] = useState();
  const [discontinuedata, setDiscontinueddata] = useState();
  const [smedata, setSmedata] = useState();
  const [combineddata, setCombineddata] = useState();
  const [sepratedata, setSeprateddata] = useState();

  const getListDatacount = async () => {
    await parentsModal
      .Parentlist("?class_status=All")
      .then((result) => {
        setAlldata(result?.meta?.total);
      })
      .catch((error) => {});
    await parentsModal
      .Parentlist("?class_status=Active")
      .then((result) => {
        setActivedata(result?.meta?.total);
      })
      .catch((error) => {});
    await parentsModal
      .Parentlist("?class_status=Hold")
      .then((result) => {
        setHolddata(result?.meta?.total);
      })
      .catch((error) => {});
    await parentsModal
      .Parentlist("?class_status=Completed")
      .then((result) => {
        setCompleteddata(result?.meta?.total);
      })
      .catch((error) => {});
    await parentsModal
      .Parentlist("?class_status=Discontinued")
      .then((result) => {
        setDiscontinueddata(result?.meta?.total);
      })
      .catch((error) => {});
    await parentsModal
      .Parentlist("?class_type=SME")
      .then((result) => {
        setSmedata(result?.meta?.total);
      })
      .catch((error) => {});
    await parentsModal
      .Parentlist("?class_type=COMBINED")
      .then((result) => {
        setCombineddata(result?.meta?.total);
      })
      .catch((error) => {});
    await parentsModal
      .Parentlist("?class_type=SEPARATE")
      .then((result) => {
        setSeprateddata(result?.meta?.total);
      })
      .catch((error) => {});
  };

  const getListData = async () => {
    setIsLoading(true);
    await parentsModal
      .Parentlist(status, parameters)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setDataList(result);
          setTotalpage(result?.meta?.total_page);
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
        setIsLoading(false);
        setDataList({ data: [] }); // Set empty data structure on error to trigger dummy data
      });
  };
  console.log("datalist parent", dataList);
  useEffect(() => {
    getListData();
    getListDatacount();
  }, [location]);
  useEffect(() => {
    getListData();
  }, [status]);

  useEffect(() => {
    getListData();
  }, [currentPage]);

  const tableRef = useRef(null);

  const downloadPDF = () => {
    const input = tableRef.current;

    if (!input) {
      console.error("Table element not found.");
      return;
    }

    html2canvas(input)
      .then((canvas) => {
        // Show action column again after capturing the table

        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const width = pdf.internal.pageSize.getWidth();
        const height = (canvas.height * width) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, width, height);
        pdf.save("Parents_list.pdf");
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };

  const [student, setStudent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_EXPRESS_API}/getAllparent`
      );
      setStudent(response.data);
      setLoading(false);
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchProducts();
  }, []);

  const handleDel = async (delId) => {
    const form = new FormData();
    form.append("is_active", "false");
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to deactive this user?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, deactive it!",
    }).then((result) => {
      if (result.isConfirmed) {
        ParentandtutoractiveModal.Active(delId, form)
          .then((res) => {
            Swal.fire("Deactive!", "The item has been deactive.", "success");
            // Refresh the list after deletion
            getListData();
          })
          .catch((error) => {
            console.error("Error deleting product:", error);
            Swal.fire(
              "Error!",
              "There was a problem dactive the item.",
              "error"
            );
          });
      }
    });
  };

  const handleAcc = async (delId) => {
    const form = new FormData();
    form.append("is_active", "true");
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to Active this user?",
      icon: "Success",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Active it!",
    }).then((result) => {
      if (result.isConfirmed) {
        ParentandtutoractiveModal.Active(delId, form)
          .then((res) => {
            Swal.fire("Activated!", "The item has been Activated.", "success");
            // Refresh the list after deletion
            getListData();
          })
          .catch((error) => {
            console.error("Error deleting product:", error);
            Swal.fire("Error!", "There was a problem ctive the item.", "error");
          });
      }
    });
  };
  
  // Dummy data for testing when no API data is available
  const dummyStudentData = [
    {
      id: 1,
      mobile: "9876543210",
      location: "Mumbai, Maharashtra",
      parent: {
        id: 1,
        first_name: "Rajesh",
        last_name: "Sharma",
        is_active: true
      },
      studentApi_students: {
        name: "Aarav Sharma"
      },
      adminApi_tutorclasses: {
        name: "Mathematics Grade 10",
        type: "COMBINED",
        tutorApi_tutor: {
          tutor: {
            first_name: "Dr. Priya",
            last_name: "Patel"
          }
        }
      },
      user: {
        id: 1,
        is_active: true
      }
    },
    {
      id: 2,
      mobile: "9876543211",
      location: "Delhi, NCR",
      parent: {
        id: 2,
        first_name: "Sunita",
        last_name: "Gupta",
        is_active: false
      },
      studentApi_students: {
        name: "Kavya Gupta"
      },
      adminApi_tutorclasses: {
        name: "Physics Grade 11",
        type: "SME",
        tutorApi_tutor: {
          tutor: {
            first_name: "Prof. Rahul",
            last_name: "Singh"
          }
        }
      },
      user: {
        id: 2,
        is_active: false
      }
    },
    {
      id: 3,
      mobile: "9876543212",
      location: "Bangalore, Karnataka",
      parent: {
        id: 3,
        first_name: "Amit",
        last_name: "Kumar",
        is_active: true
      },
      studentApi_students: {
        name: "Arjun Kumar"
      },
      adminApi_tutorclasses: {
        name: "Chemistry Grade 12",
        type: "SEPARATE",
        tutorApi_tutor: {
          tutor: {
            first_name: "Dr. Meera",
            last_name: "Joshi"
          }
        }
      },
      user: {
        id: 3,
        is_active: true
      }
    },
    {
      id: 4,
      mobile: "9876543213",
      location: "Chennai, Tamil Nadu",
      parent: {
        id: 4,
        first_name: "Lakshmi",
        last_name: "Raman",
        is_active: true
      },
      studentApi_students: {
        name: "Diya Raman"
      },
      adminApi_tutorclasses: {
        name: "English Literature",
        type: "COMBINED",
        tutorApi_tutor: {
          tutor: {
            first_name: "Ms. Sarah",
            last_name: "Johnson"
          }
        }
      },
      user: {
        id: 4,
        is_active: true
      }
    },
    {
      id: 5,
      mobile: "9876543214",
      location: "Pune, Maharashtra",
      parent: {
        id: 5,
        first_name: "Vikram",
        last_name: "Mehta",
        is_active: false
      },
      studentApi_students: {
        name: "Rohan Mehta"
      },
      adminApi_tutorclasses: {
        name: "Computer Science",
        type: "SME",
        tutorApi_tutor: {
          tutor: {
            first_name: "Mr. Anil",
            last_name: "Verma"
          }
        }
      },
      user: {
        id: 5,
        is_active: false
      }
    }
  ];

  // Use dummy data if no API data is available, otherwise filter the actual data
  const filteredData = dataList?.data?.length > 0 
    ? dataList.data.filter((item) => {
        const fullName = `${item?.parent?.first_name} ${item?.parent?.last_name}`.toLowerCase();
        const tutorFullName = `${item?.adminApi_tutorclasses?.tutorApi_tutor?.tutor?.first_name || ""} ${item?.adminApi_tutorclasses?.tutorApi_tutor?.tutor?.last_name || ""}`.toLowerCase();
        const className = item?.adminApi_tutorclasses?.name?.toLowerCase() || "";
        const classType = item?.adminApi_tutorclasses?.type?.toLowerCase() || "";
        const studentName = item?.studentApi_students?.name?.toLowerCase() || "";
        
        return (
          fullName.includes(searchQuery.toLowerCase()) ||
          item?.mobile?.includes(searchQuery) ||
          item?.location?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          tutorFullName.includes(searchQuery.toLowerCase()) ||
          className.includes(searchQuery.toLowerCase()) ||
          classType.includes(searchQuery.toLowerCase()) ||
          studentName.includes(searchQuery.toLowerCase())
        );
      })
    : dummyStudentData.filter((item) => {
        const fullName = `${item?.parent?.first_name} ${item?.parent?.last_name}`.toLowerCase();
        const tutorFullName = `${item?.adminApi_tutorclasses?.tutorApi_tutor?.tutor?.first_name || ""} ${item?.adminApi_tutorclasses?.tutorApi_tutor?.tutor?.last_name || ""}`.toLowerCase();
        const className = item?.adminApi_tutorclasses?.name?.toLowerCase() || "";
        const classType = item?.adminApi_tutorclasses?.type?.toLowerCase() || "";
        const studentName = item?.studentApi_students?.name?.toLowerCase() || "";
        
        return (
          fullName.includes(searchQuery.toLowerCase()) ||
          item?.mobile?.includes(searchQuery) ||
          item?.location?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          tutorFullName.includes(searchQuery.toLowerCase()) ||
          className.includes(searchQuery.toLowerCase()) ||
          classType.includes(searchQuery.toLowerCase()) ||
          studentName.includes(searchQuery.toLowerCase())
        );
      });

  console.log("rrrrrrrr", dataList);

  return (
    <>
      <div className="pt-7 px-4 overflow-x-hidden">
        <Row>
          <div className="col">
            <Card className="shadow">
              <div style={{ marginTop: "20px" }}>
                <Row
                  className="mb-1 px-4"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Col
                    md={7}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "nowrap",
                      justifyContent: "space-between",
                      border: "1px solid black",
                    }}
                  >
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color: status == "?class_status=All" ? "blue" : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_status=All");
                      }}
                    >
                      <span>All</span>{" "}
                      <span className="badge bg-secondary ms-1 ">
                        ({" "}
                        <span
                          style={{
                            color:
                              status == "?class_status=All" ? "black" : "blue",
                            cursor: "pointer",
                          }}
                        >
                          {alldata}{" "}
                        </span>
                        )
                      </span>
                    </div>
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color:
                          status == "?class_status=Active" ? "blue" : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_status=Active");
                      }}
                    >
                      <span>Active</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        ({" "}
                        <span
                          style={{
                            color:
                              status == "?class_status=Active"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {activedata}{" "}
                        </span>
                        )
                      </span>
                    </div>
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color:
                          status == "?class_status=Hold" ? "blue" : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_status=Hold");
                      }}
                    >
                      <span>Hold</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        ({" "}
                        <span
                          style={{
                            color:
                              status == "?class_status=Hold" ? "black" : "blue",
                          }}
                        >
                          {holddata}{" "}
                        </span>
                        )
                      </span>
                    </div>
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color:
                          status == "?class_status=Completed"
                            ? "blue"
                            : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_status=Completed");
                      }}
                    >
                      <span>Completed</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        ({" "}
                        <span
                          style={{
                            color:
                              status == "?class_status=Completed"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {completeddata}{" "}
                        </span>
                        )
                      </span>
                    </div>
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color:
                          status == "?class_status=Discontinued"
                            ? "blue"
                            : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_status=Discontinued");
                      }}
                    >
                      <span>Discontinued</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        ({" "}
                        <span
                          style={{
                            color:
                              status == "?class_status=Discontinued"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {discontinuedata}{" "}
                        </span>
                        )
                      </span>
                    </div>
                  </Col>
                  <Col md={1}></Col>
                  <Col
                    md={4}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "nowrap",
                      justifyContent: "space-between",
                      border: "1px solid black",
                    }}
                  >
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color:
                          status == "?class_type=COMBINED" ? "blue" : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_type=COMBINED");
                      }}
                    >
                      <span>Combined</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        ({" "}
                        <span
                          style={{
                            color:
                              status == "?class_type=COMBINED"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {combineddata}{" "}
                        </span>
                        )
                      </span>
                    </div>
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color: status == "?class_type=SME" ? "blue" : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_type=SME");
                      }}
                    >
                      <span>SME</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        ({" "}
                        <span
                          style={{
                            color:
                              status == "?class_type=SME" ? "black" : "blue",
                          }}
                        >
                          {smedata}{" "}
                        </span>
                        )
                      </span>
                    </div>
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color:
                          status == "?class_type=SEPARATE" ? "blue" : "black",
                      }}
                      onClick={() => {
                        setStatus("?class_type=SEPARATE");
                      }}
                    >
                      <span>Separate</span>{" "}
                      <span className="badge bg-secondary ms-1">
                        ({" "}
                        <span
                          style={{
                            color:
                              status == "?class_type=SEPARATE"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {sepratedata}{" "}
                        </span>
                        )
                      </span>
                    </div>
                  </Col>
                </Row>
              </div>
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">All Parent</h3>

                <div className="d-flex flex-row">
                  {/* <i class="fa-solid fa-magnifying-glass"></i> */}
                  <Input
                    className="mr-md-4 mb-2 mb-md-0 ml-md-4"
                    type="text"
                    placeholder="Search"
                    size="sm"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <Button
                    size="sm"
                    onClick={downloadPDF}
                    // style={{ width: "1x" }}
                  >
                    <i class="fa-solid fa-download"></i>
                  </Button>
                  {/* <Button
                  className="p-3"
                  size="sm"
                  to="/admin/student/addstudent"
                  tag={Link}
                >
                  +Add
                </Button> */}
                </div>
              </CardHeader>
              <div
                ref={tableRef}
                style={{ maxWidth: "100%", overflowX: "auto" }}
              >
                <Row className="table-container">
                  <Col>
                    <Table>
                      <thead>
                        <tr>
                          <th>SN NO.</th>
                          <th>Student/Parent</th>
                          <th>Tutor</th>
                          <th>Class Name</th>
                          <th>Contact Details</th>
                          <th>Location</th>
                          <th>Status</th>
                          <th>Type</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {isLoading ? (
                          <tr>
                            <td
                              colSpan={9}
                              className="text-center align-middle py-4"
                            >
                              Please wait...
                              <Loader />
                            </td>
                          </tr>
                        ) : filteredData?.length > 0 ? (
                          filteredData?.map((item, index) => {
                            console.log("parent 25", item);
                            return (
                              <tr key={item.id}>
                                <td style={{ padding: "0.3rem" }}>
                                  {index + 1}
                                </td>
                                <td style={{ padding: "0.3rem" }}>
                                  <Link
                                    to={`/admin/student/parentsProfile/${item?.parent?.id}/${item?.mobile}`}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <div>
                                        <span style={{ color: "gray" }}>
                                          Parent-{" "}
                                        </span>
                                        <span>
                                          {item?.parent?.first_name
                                            ? `${item?.parent?.first_name} ${item?.parent?.last_name}`
                                            : "-"}
                                        </span>
                                      </div>
                                      <span
                                        style={{
                                          color: "gray",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {item?.studentApi_students?.name}
                                      </span>
                                    </div>
                                  </Link>
                                </td>
                                <td style={{ padding: "0.3rem" }}>
                                  {item?.adminApi_tutorclasses?.tutorApi_tutor
                                    ?.tutor?.first_name || " - "}
                                </td>
                                <td style={{ padding: "0.3rem" }}>
                                  {item?.adminApi_tutorclasses.name || "-"}
                                </td>
                                <td style={{ padding: "0.3rem" }}>
                                  {item?.mobile || "-"}
                                </td>
                                <td style={{ padding: "0.3rem" }}>
                                  {item?.location || "-"}
                                </td>
                                <td style={{ padding: "0.3rem" }}>
                                  <Badge
                                    className={
                                      item?.parent?.is_active == true
                                        ? "status-active"
                                        : "status-discontinued"
                                    }
                                  >
                                    {item?.parent?.is_active
                                      ? "Active"
                                      : "Deactive"}
                                  </Badge>
                                </td>
                                <td style={{ padding: "0.3rem" }}>
                                  {item?.adminApi_tutorclasses?.type || "-"}
                                </td>
                                <td
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",

                                    alignItems: "center",
                                    padding: "0.3rem",
                                  }}
                                >
                                  <UncontrolledTooltip
                                    className="p-0"
                                    placement="top"
                                    target="eyeTooltip"
                                  >
                                    View
                                  </UncontrolledTooltip>
                                  <Link
                                    style={{
                                      margin: "0 5px",
                                      fontSize: "15px",
                                      color: "blue",
                                      marginTop: "10px",
                                      display: "inline-block",
                                      // padding: "5px", // Optional: Add padding for better appearance
                                      borderRadius: "30%", // Optional: Make it a circle
                                    }}
                                    id="eyeTooltip"
                                    to={`/admin/student/parentsProfile/${item?.parent?.id}/${item?.mobile}`}
                                    // tag={Link}
                                  >
                                    <i class="fa-solid fa-eye"></i>
                                  </Link>

                                  {item?.user?.is_active == false && (
                                    <>
                                      <UncontrolledTooltip
                                        placement="top"
                                        target={`userTooltip${index}`}
                                      >
                                        Active
                                      </UncontrolledTooltip>
                                      <p
                                        style={{
                                          margin: "0 8px",
                                          fontSize: "15px",
                                          color: "green",
                                          marginTop: "10px",
                                          // backgroundColor: "#f5f5f5",
                                          display: "inline-block",
                                          // padding: "5px", // Optional: Add padding for better appearance
                                          borderRadius: "20%", // Optional: Make it a circle
                                        }}
                                        id={`userTooltip${index}`}
                                        onClick={() =>
                                          handleAcc(item?.user?.id)
                                        }
                                      >
                                        <i class="fa-solid fa-user-plus"></i>
                                      </p>
                                    </>
                                  )}
                                  {item?.user?.is_active == true && (
                                    <>
                                      <UncontrolledTooltip
                                        placement="top"
                                        target={`userTooltip1${index}`}
                                      >
                                        Deactive
                                      </UncontrolledTooltip>
                                      <p
                                        style={{
                                          margin: "0 8px",
                                          fontSize: "15px",
                                          color: "red",
                                          marginTop: "10px",
                                          // backgroundColor: "#f5f5f5",
                                          display: "inline-block",
                                          // padding: "5px", // Optional: Add padding for better appearance
                                          borderRadius: "20%", // Optional: Make it a circle
                                        }}
                                        id={`userTooltip1${index}`}
                                        onClick={() =>
                                          handleDel(item?.user?.id)
                                        }
                                      >
                                        <i class="fa-solid fa-user-xmark"></i>
                                      </p>
                                    </>
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td
                              colSpan="9"
                              style={{ textAlign: "center", padding: "1rem" }}
                            >
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </div>
              <CardFooter className="">
                <TablePagination
                  totalPages={dataList?.meta?.total_page}
                  currentPage={dataList?.meta?.current_page}
                  pageUrl="/admin/student?"
                />
              </CardFooter>
            </Card>
          </div>
        </Row>

        <AddModal
          modal={modal}
          Name="Add6"
          toggle={toggleModal}
          title="Add Fare management"
        />
      </div>
    </>
  );
};

export default Students;
